<template>
    <div>
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderNumber" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="fetchData">查询</el-button>
        </el-form-item>
      </el-form>
  
      <!-- 数据表格 -->
      <tablePagination :total="total" :pageSize="searchForm.pageSize" @handlePage="handlePageChange">
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="orderNumber" label="订单号" width="160"/>
            <el-table-column prop="trackingNumber" label="物流单号" width="160"/>
            <el-table-column prop="orderRemark" label="订单备注"/>
            <el-table-column prop="createTime" label="创建时间" width="180"/>
            <el-table-column prop="updateTime" label="更新时间" width="180"/>
        </el-table>
        </tablePagination>
      
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  import defaultSec from '@c/defaultSection'
  import tablePagination from '@c/tablePagination'


  export default {
    name: 'OrderLogisticsUser',
    data() {
      return {
        searchForm: {
          orderNumber: '',
          customerId: this.$route.query.customerId||'',
          qyWeixinUserId: '',
          pageSize: 10,
          userid:this.$route.query.userid||'',
          currentPage: 1,
        },
        tableData: [],
        total: 0,
      }
    },
    mounted() {
      //打印 当前路由参数
      console.log('当前路由参数:', this.$route.query);
      //当前路由参数: {customerId: '3071631527888182716', userid: '3082133806849985211'}
        if (this.$route.query.customerId) {
            console.log(121212)
            this.fetchData()
        }
      
    },
    methods: {
      fetchData() {
        if (!this.searchForm.customerId) {
          this.$message.error('查询参数为空')
          return
        }
        //this.$route.query.
        if(!this.searchForm.userid){
          this.$message.error('查询参数为空')
          return
        } 

        this.$apiGet('lechun-cms/scrmOrder/getDataList', { ...this.searchForm }).then(res => {
            console.log(res)
            this.total = res.total|| 0;
            this.tableData = res.list|| []
        })
      },
      handlePageChange(page) {
        this.searchForm.currentPage = page
        this.fetchData()
      },
      
    }
  }
  </script>
  
  <style scoped>
  .mb-4 {
    margin-bottom: 20px;
  }
  .mt-4 {
    margin-top: 20px;
  }
  </style>
  